const noop = () => {
  /* noop */
};

export { noop };
